<template>
  <div class="empty">
    <mt-header fixed :title="getTitleStr" class="title1">
      <mt-button slot="left" icon="back" @click="backClickHandler">返回</mt-button>
    </mt-header>
    <div class="content">
      <div class="img">
        <img :src="require('@/assets/order-empty.png')" alt />
      </div>
      <div class="word">
        <span>这里什么都没有</span>
      </div>
      <div class="word">
        <span>去看看别的</span>
      </div>
    </div>
  </div>
</template>

<script>
/* global PUBLIC_EMPTY_TITLE */

export default {
  name: 'Empty',
  data() {
    return {
      titleStr: PUBLIC_EMPTY_TITLE,
    };
  },
  computed: {
    getTitleStr() {
      switch (PUBLIC_EMPTY_TITLE) {
        case '1':
          return '交易记录';
        case '2':
          return '计划管理';
        case '3':
          return '积分兑换';
        default:
          return '';
      }
    },
  },
  methods: {
    backClickHandler() {
      window.location.href = 'protocol://android';
    },
  },
};
</script>
